module.exports = __webpack_public_path__ + "img/logo.89a04d9f.png";